<template>
  <footer class="footer pt-4 pb-2">
    <div class="container-fluid">
      <div class="row align-items-center text-center text-md-start">
        <div class="col-12 col-md-3 mb-2 mb-md-0">
          <img
            src="@/assets/WebAppByNemo.png"
            alt="Logo"
            style="max-height: 30px; max-width: 150px"
          />
        </div>

        <div class="col-md-6 text-center mb-2 mb-md-0 d-flex flex-column flex-sm-row align-items-center justify-content-center gap-2 gap-md-3">
            <small class="text-nowrap">
              © Nemoprod {{ new Date().getFullYear() }}
            </small>
            <small class="text-nowrap ">
              <a href="/MyNemo-CGU.pdf" target="_blank" class="link-dark">Mentions Légales</a> -
              <a href="/MyNemo-CGU.pdf" target="_blank" class="link-dark">Données Personnelles</a>
            </small>
        </div>

        <div class="col-md-3 text-md-end text-center">
          <a
            href="https://www.facebook.com/AgenceNemoprod/?locale=fr_FR"
            target="_blank"
            class="ms-4"
          >
            <span class="fa-stack">
              <i class="fa-solid fa-circle fa-stack-2x"></i>
              <i class="fa-brands fa-facebook-f fa-stack-1x fa-inverse"></i>
            </span>
          </a>
          <a href="https://www.instagram.com/nemoprod" target="_blank" class="ms-4">
            <span class="fa-stack">
              <i class="fa-solid fa-circle fa-stack-2x"></i>
              <i class="fa-brands fa-instagram fa-stack-1x fa-inverse"></i>
            </span>
          </a>
          <a href="https://vimeo.com/nemoprod" target="_blank" class="ms-4">
            <span class="fa-stack">
              <i class="fa-solid fa-circle fa-stack-2x"></i>
              <i class="fa-brands fa-vimeo-v fa-stack-1x fa-inverse"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>
